import script from "./ScreenRequestSlot.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenRequestSlot.vue?vue&type=script&setup=true&lang=js"

import "./ScreenRequestSlot.vue?vue&type=style&index=0&id=35916312&lang=scss"

const __exports__ = script;

export default __exports__